import React from 'react';
import { Box, Typography } from '@mui/material';

const AdminDefaultPage = () => {
  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" style={{ height: '100vh' }}>
      <Typography variant="h4" component="h2" fontWeight="bold">
        Welcome to the Admin Dashboard
      </Typography>
      <Typography variant="body1" color="text.secondary" mt={2}>
        Select an option from the menu to get started.
      </Typography>
    </Box>
  );
};

export default AdminDefaultPage;
